import React from "react";
import { useLocation } from "react-router-dom";
import { useCurrentFullAccountPage, useIsMobile } from "@hooks";
import { ACCOUNT_SETTINGS, ALL_ASSISTANTS, CAMPAIGN_MANAGER } from "@consts";
import { TopContainer } from "../LayoutWrappers";
import MobileNavigationBar from "../Navigation/MobileNavigationBar";
import CampaignManagerBreadcrumbs from "src/components/widgets/campaign-manager/CampaignManagerBreadcrumbs";

const AccountHeader = (props) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const page = useCurrentFullAccountPage();
  const isAllAgentsPage = page === ALL_ASSISTANTS;
  const isAccountSettingsPage = page === ACCOUNT_SETTINGS;
  const showCampaignManagerBreadcrumbs = location?.pathname.includes(CAMPAIGN_MANAGER);

  if (isAllAgentsPage || isAccountSettingsPage) return null;

  return <TopContainer showBreadcrumbs={showCampaignManagerBreadcrumbs}>
    {isMobile && <MobileNavigationBar {...props} useCurrentPage={useCurrentFullAccountPage} />}
    {showCampaignManagerBreadcrumbs ? <CampaignManagerBreadcrumbs /> : null}
  </TopContainer>;
};

export default AccountHeader;
